module.exports = __webpack_public_path__ + "img/pic3.7720a874.png";